// import logo from './logo.svg';
import React, { Component, Fragment } from 'react';
import {
  BrowserRouter as Router, Route, Switch
} from "react-router-dom";
import { getPubRoutes, getSetting } from './actions/Utils';
import './App.css';
import FooterLoad from './components/common/FooterLoad';
import HeaderLoad from './components/common/HeaderLoad';
import { base_path } from './config/Api';
import Contactus from './layout/Contactus';
import Faq from './layout/Faq';
import HomeLayout from './layout/Home';
import Member from './layout/MemberLayout';
import CommonLanding from './page/CommonLanding';
import AnnualReport from './publication/page/AnnualReport';
import Sitemap from './publication/page/Sitemap';
import CommonList from './publication/page/CommonList';
import PublicationHome from './publication/page/Home';
import NewsDetails from './publication/page/NewsDetails';
import SearchPage from './publication/page/SearchPage';
import TagNewsPage from './publication/page/TagNewsPage';
import configureStore from './store/Configurstore';
// import Notifications from './components/Notifications/Notifications';

import AricleSubmissionForm from './publication/layout/AricleSubmissionForm';

const store = configureStore();


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      utils: store.getState().utils,
      routemenu: store.getState().utils.routemenu,
      pubroutemenu: store.getState().utils.pubroutemenu,
    };


  }

  componentDidMount = () => {

    
    store.dispatch(getPubRoutes()).then((res) => {
      // console.log(" route data = ",res);
      this.setState({ pubroutemenu: res })
    });

    // store.dispatch(getTopMenu()).then((res) => {
    //   // console.log('Header data = ',res);
    // });
    // store.dispatch(getRightSiteMenu()).then((res) => {
    //   // console.log('Header data = ',res);
    // });
    // // store.dispatch(getHeaderSection()).then((res) => {
    // //   // console.log('Header data = ',res);
    // // });

    // store.dispatch(getFooterSection()).then((res) => {
    //   // console.log('Footer data = ',res);
    // });
    store.dispatch(getSetting()).then((res) => {
      // console.log('Footer data = ',res);
    });



  }

  render() {
    // console.log('app routemenu js file = ',this.state.routemenu);
    const routemenu =[];// this.state.routemenu;
    const pubroutemenu = this.state.pubroutemenu;

    var site = base_path.split("/");
    // let pathName = this.state.utils.path;

    var basename = "/";
     if (site.includes("www.icab.com") || site.includes("3000")) {
      basename = "/";
    }
   
    else if (site.includes("devtest")) {
      basename = "/devtest/icab_frontend2/publication/";
    }
    else {
      basename = "/";
    } 
  //  console.log(" Hello process.env.PUBLIC_URL =",process.env.PUBLIC_URL);
    return (
      <Router basename={'/publication/'}>
        <Fragment>
          {/* <Notifications /> */}
          <HeaderLoad />
          
          {/* <CommonHeader /> */}
          <Switch>
            {/* <Route exact  path={`/`} >
              <HomeLayout />
            </Route> */}
           
            {/* <Route path="/login">
              <Login />
            </Route> */}

            {/* <Route path={`${process.env.PUBLIC_URL}/register`}>
              <Register />
            </Route>
            */}
          
            {/* <Route path={`${process.env.PUBLIC_URL}/page/:slug`}>
              <PageLayout />
            </Route> */}

            {/* <Route path={`${process.env.PUBLIC_URL}/news/:slug`}>
              <NewsLayout />
            </Route> */}


            {/* <Route path={`${process.env.PUBLIC_URL}/search/:slug`}>
              <SearchLayout />
            </Route> */}


            <Route exact path="/">
              <PublicationHome />
            </Route>
            
           
            <Route exact path={`/news/:catid/:id/:slug`} >
              <NewsDetails/>
            </Route>
            <Route exact path={`/article-submission-form`}>
              <AricleSubmissionForm />
            </Route>

            <Route path={`/search/:slug`}>
              <SearchPage />
            </Route>
            <Route path={`/tag/:slug`}>
              <TagNewsPage />
            </Route>



            {routemenu.map((menu, index,{length}) => {
                if(menu.layout) {
                  //if(index + 1 === length) { 
                      if(menu.layout.name.toLowerCase() == 'home') {
                        return <Route key={menu.id} exact path={`${process.env.PUBLIC_URL}${menu.slug}`} render={() => <HomeLayout />}/>
                      }
                      if(menu.layout.name.toLowerCase() == 'common landing'){
                      
                        return <Route key={menu.id} exact path={`${process.env.PUBLIC_URL}${menu.slug}`} render={() => <CommonLanding />}/>
                          
                      }
                      
                      if(menu.layout.name.toLowerCase() == 'faq') {
                        return <Route key={menu.id} exact path={`${process.env.PUBLIC_URL}${menu.slug}`} render={() => <Faq />}/>
                          
                        
                      }
                      if(menu.layout.name.toLowerCase() == 'gallery'){
                        return <Route key={menu.id} exact path={`${process.env.PUBLIC_URL}${menu.slug}`} render={() => <CommonLanding />}/>
                          
                      
                      }
                      

                      if(menu.layout.name.toLowerCase() == 'contact us'){
                        return <Route key={menu.id} exact path={`${process.env.PUBLIC_URL}${menu.slug}`} render={() => <Contactus />}/>
                      }


                      if(menu.layout.name.toLowerCase() == 'member'){
                       
                        return <Route key={menu.id} exact path={`${process.env.PUBLIC_URL}${menu.slug}`} render={() => <Member />}/>
                      }
                      
                    
                }
                else {
                  return <Route key={menu.id} exact path={`${process.env.PUBLIC_URL}${menu.slug}`} render={() =>  '404 NOT FOUND'}/>
                }




                  // if(index + 1 === length) { 
                  //   return <Fragment key={index}>
                  //     <Route key={menu.id} exact path={menu.slug} render={() => <CommonComponent />}/>
                  //     {/* <Route path="*" component={() => "404 NOT FOUND"} /> */}
                  //   </Fragment>
                  // }
                  // else {
                  //   return <Route key={menu.id} exact path={menu.slug} render={() => <CommonComponent />}/>
                  // }
                 
                })}

                  {pubroutemenu.map((menu, index,{length}) => {
                    // console.log('pubroutemenu =',menu);
                  if(menu.id === 1){
                    return <Route key={menu.id} exact path={`/${menu.slug}`} render={() => <PublicationHome />}/>
                  }
                  // if(menu.id === 3 ){
                  //   return <Route key={menu.id} exact path={`/${menu.slug}`} render={() => <NewsBulletin />}/>
                  // }
                  if(menu.id === 6 ){
                    return <Route key={menu.id} exact path={`/${menu.slug}`} render={() =>  <AnnualReport />}/>
                  }
                  if(menu.id === 45 ){
                    return <Route key={menu.id} exact path={`/${menu.slug}`} render={() =>  <Sitemap />}/>
                  }
                  if(menu.id !== 1 || menu.id !== 3 || menu.id !== 6 ||  menu.id !== 36){
                    return <Route key={menu.id} exact path={`/${menu.slug}`} render={() => <CommonList />}/>
                  }
                  
                    
                 
                })}
          
          </Switch>
          {/* <Footer /> */}
          <FooterLoad />
        </Fragment>
      </Router>
    );
  }
}

export default App;

